import { api } from "../../../services/rpc/RpcProvider";

export const useStepExecutionLog = (stepId: string) => {
  const { data: logs } = api.execution.logs.list.useQuery({ stepId });

  return { logs };
};
